import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>
  The selected parcel(s)/area contains Crown Land. The levy liability estimate is calculated for the portion covering
  Crown Land only.
    </p>
    <p>
  You can review areas covered by Crown Land by turning on the <strong>Crown Land</strong> layer on the map.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      